import React from "react";
import { Card, CardContent, CardMedia, Typography, Button, Grid, Box } from "@mui/material";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const halls = [
  {
    name: "Press Conference Hall",
    image: "https://patrakarbhavan.com/Services/PC%20Hall%201.jpg",
    route: "/managePressConfHall", // Define the route for each hall
  },
  {
    name: "Community Hall",
    image: "https://patrakarbhavan.com/Services2/Hall%202.jpeg",
    // route: "/manageComHall",
    "route":"/Bookings"
  },
  {
    name: "Croma Video Shooting Hall",
    image: "https://patrakarbhavan.com/Services2/Chroma%20Studio%201.jpg",
    // route: "/manageChromaShooting",
    "route":"/Bookings"
  },
];

function Tables() {
  const navigate = useNavigate(); // Initialize the navigation hook

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3} padding={3} justifyContent="center">
        {halls.map((hall, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Card sx={{ boxShadow: 3 }}>
              <CardMedia component="img" height="280" image={hall.image} alt={hall.name} />
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Typography variant="h5" align="center" fontWeight="bold" color="text.primary">
                    {hall.name}
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 2,
                      bgcolor: "limegreen",
                      color: "white", // Ensuring white text
                      "&:hover": { bgcolor: "green" },
                    }}
                    onClick={() => navigate(hall.route)} // Navigate to the respective page
                  >
                    Manage
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
